/**
 * HTTP Headers 封装
 * @author Fan Niu
 * @since 2019-08-09
 */

/**
 * HTTP header key
 */
export class HeaderKey {
  static CONTENT_TYPE = 'Content-Type'
}

/**
 * HTTP Media type
 */
export class MediaType {
  static APPLICATION_JSON_UTF_8 = 'application/json; charset=utf-8';
  static APPLICATION_FORM_URLENCODED = 'application/x-www-form-urlencoded';
  static MULTIPART_FORM_DATA = 'multipart/form-data'
}

/**
 * HTTP Header Builder
 */
export class HeaderBuilder {
  constructor(headers = {}) {
    this.headers = headers;
  }
  put(key, value) {
    this.headers[key] = value;
    return this;
  }
  build() {
    return {
       headers:this.headers
    };
  }
  static json() {
    return new HeaderBuilder().put(HeaderKey.CONTENT_TYPE, MediaType.APPLICATION_JSON_UTF_8).build();
  }
  static form() {
    return new HeaderBuilder().put(HeaderKey.CONTENT_TYPE, MediaType.APPLICATION_FORM_URLENCODED).build();
  }
  static multipartForm() {
    return new HeaderBuilder().put(HeaderKey.CONTENT_TYPE, MediaType.MULTIPART_FORM_DATA).build();
  }
  static getHeadersByLocalStorage(keys) {
    let builder = new HeaderBuilder();
    keys.forEach((key) => {
      builder.put(key, encodeURIComponent(localStorage.getItem(key)));
    });
    return builder.build();
  }
  static getBillingUserAuthInfo(authorizes) {
    let sites = [];
    let authSites = localStorage.getItem('authsites').split(',');
    for (let i = 0, len = authSites.length; i < len;i ++) {
      let authSite = authSites[i];
      if (authSite !== '') {
        sites.push(String(eval('(' + authSites[i] + ')'))) ;
      }
    }
    return {
      appId: localStorage.getItem('appId'),
      token: localStorage.getItem('token'),
      userId: localStorage.getItem('userid'),
      authorg: localStorage.getItem('authorg'),
      authScope: {
        sites: sites,
        orgs: [localStorage.getItem('authorg')],
        userId: localStorage.getItem('userid')
      },
      authorizes: authorizes || []
    };
  }
  static getHeadersByBilling(authorizes) {
    let builder = new HeaderBuilder();
    let userAuthInfo = HeaderBuilder.getBillingUserAuthInfo(authorizes);
    builder.put("User-Auth-Info", encodeURIComponent(JSON.stringify(userAuthInfo)));
    return builder.build();
  }
}
